import {gql} from "@apollo/client";

export const LK_QUERY = gql`
    query Lk {
        userInfo {
            roles
        }
    }
`
